export default {
  groupName: 'discover',
  appName: 'Discover',
  baseRoute: '/dashboard/discover',
  label: 'Discover Ad Dashboard',
  home: '/slicer',
  image: 'discover.png',
  description: 'Discover Advertising Dashboard'
}



// WEBPACK FOOTER //
// ./src/app/configuration/Discover/config/main.js